<template>
  <router-view />

  <!-- WhatsApp Floating Action Button — all pages -->
  <a
    href="https://wa.me/250782336854?text=Hello!%20I%27d%20like%20to%20book%20a%20car%20rental%20with%20Kigali%20Rwanda%20Car%20Hire."
    target="_blank"
    rel="noopener noreferrer"
    title="Book car hire Kigali via WhatsApp"
    class="whatsapp-fab"
    aria-label="Chat on WhatsApp"
  >
    <!-- Pulse ring -->
    <span class="whatsapp-pulse"></span>

    <!-- WhatsApp icon -->
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="whatsapp-icon">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>

    <!-- Label — hidden on very small screens, shown on slightly larger mobile -->
    <span class="whatsapp-label">Book Now</span>
  </a>
</template>

<script>
export default {
  mounted () {
    document.title = 'Kigali Rwanda Car Hire | (+250) 782 336 854'
  }
}
</script>

<style scoped>
.whatsapp-fab {
  position: fixed;
  bottom: 24px;
  right: 20px;
  z-index: 999;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #25D366;
  color: #fff;
  border-radius: 50px;
  padding: 14px 18px 14px 14px;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.45);
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.whatsapp-fab:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 28px rgba(37, 211, 102, 0.55);
}

.whatsapp-icon {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}

.whatsapp-label {
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

/* Pulse ring animation */
.whatsapp-pulse {
  position: absolute;
  inset: 0;
  border-radius: 50px;
  background-color: #25D366;
  animation: waPulse 2.5s ease-out infinite;
  z-index: -1;
}

@keyframes waPulse {
  0%   { transform: scale(1);   opacity: 0.6; }
  70%  { transform: scale(1.35); opacity: 0; }
  100% { transform: scale(1.35); opacity: 0; }
}

/* On very small phones hide the label to save space */
@media (max-width: 359px) {
  .whatsapp-fab {
    padding: 14px;
    border-radius: 50%;
  }
  .whatsapp-label {
    display: none;
  }
}
</style>
